/**
 * JobParamsService
 */
angular.module('elogbooksServices').service('jobParamsService', function (elbSettings, paramConverterService) {

    this.getJobParams = getJobParams;

    /**
     * Format state params into expected job filter params for api
     *
     * @param {object} $stateParams - State params
     * @returns {object} params
     */
    function getJobParams($stateParams, user, selectedSiteResponse) {

        // remove status from stateparams passedto jobparams
        var originalParams = angular.copy($stateParams);
        delete originalParams.status;

        // Weekly, Monthly, Yearly
        var frequency = ['4', '5', '6'].indexOf(String($stateParams.jobsFrequency)) !== -1 ? String($stateParams.jobsFrequency) : null;

        var params = angular.extend(
            {},
            originalParams,
            {
                page: $stateParams.jobsPage,
                limit: $stateParams.jobsLimit,
                order: $stateParams.jobsOrder,

                id: $stateParams.jobId,
                type: $stateParams.jobsType,
                'sites[]': $stateParams.siteIds,
                'sourceType[]': $stateParams.sourceType,
                'site': $stateParams.site,
                'status[]': $stateParams.jobStatus,
                'assetTypes[]': $stateParams.assetTypes,
                'statType[]': $stateParams.statType,
                'jobPriority[]': $stateParams.jobPriority,
                'jobApprover[]': $stateParams.approver,
                'siteRegion[]': $stateParams.jobSiteRegion,
                'serviceProviders[]': $stateParams.serviceProviders,
                'jobGroups[]': $stateParams.jobGroups,
                'siteGroups[]': $stateParams.jobSiteGroups,
                'sectors[]': $stateParams.sectors,
                chargeType: $stateParams.chargeType,
                overdueAttendance: $stateParams.jobsOverdueAttendance,
                overdueCompletion: $stateParams.jobsOverdueCompletion,
                statutory: $stateParams.jobsStatutory,
                attendanceDueAtBetween: $stateParams.jobsAttendanceDueAtBetween,
                completionDueAtBetween: $stateParams.jobsCompletionDueAtBetween,
                serviceProvider: $stateParams.jobsServiceProvider,
                reminderAtBetween: $stateParams.jobsReminderAtBetween,
                iAmTheCurrentApprover: $stateParams.iAmTheCurrentApprover,
                iAmTheExtensionApprover: $stateParams.iAmTheExtensionApprover,
                jobsReminderAtEnd: $stateParams.jobsReminderAtEnd,
                jobsAttendanceDueStart: $stateParams.jobsAttendanceDueStart,
                jobsAttendanceDueEnd: $stateParams.jobsAttendanceDueEnd,
                completionDueStart: $stateParams.completionDueStart,
                completionDueEnd: $stateParams.completionDueEnd,
                overdueAttendancePerformance: $stateParams.jobsOverdueAttendancePerformance,
                asset: $stateParams.asset,
                subAsset: $stateParams.subAsset,
                fromJob: $stateParams.fromJob,
                completedAtStart: $stateParams.completedAtStart,
                completedAtEnd: $stateParams.completedAtEnd,
                remedial: $stateParams.jobsRemedial,
                watchedJobs: $stateParams.watchedJobs,
                // Unsupported values and an interval without a frequency are left out of the request, the interval is capped to 1-52
                frequency: frequency,
                frequencyInterval: frequency ? paramConverterService.clampToRange($stateParams.jobsFrequencyInterval, 1, 52) : null,
                'documentTypes[]': $stateParams.documentTypes,
                hasDocumentType: $stateParams.jobsHasDocumentType,
                'prosureStatusAtCompletion[]': $stateParams.prosureStatusAtCompletion,
                'prosureStatusAtApproval[]': $stateParams.prosureStatusAtApproval,
                jobApprovedByUser: $stateParams.jobApprovedByUser,
                jobRequisitePendingCompletion: $stateParams.jobRequisitePendingCompletion,
                'jobRequisitePendingApproval[]': $stateParams.jobRequisitePendingApproval,
                orderByUserName: $stateParams.orderByUserName
            }
        );

        if (elbSettings.getSetting('meridian_enabled').value) {
            params.externalSystem = $stateParams.externalSystem || null;
        }

        if ($stateParams.jobSiteGroup) {
            params.siteGroup = JSON.parse($stateParams.jobSiteGroup).v;
        }

        if ($stateParams.createdBy) {
            params.createdBy = JSON.parse($stateParams.createdBy).v;
        }

        if ($stateParams.approver) {
            params['jobApprover[]'] = JSON.parse($stateParams.approver).v;
            params.approver = JSON.parse($stateParams.approver).v;
        }

        //Set the approver as the current user when transferring from dashboard
        if ($stateParams.jobApprover) {
            if ($stateParams.jobApprover[0] === 'true') {
                params['jobApprover[]'] = user.id;
            }
        }

        // override site filter if selectedsite is set
        if (selectedSiteResponse) {
            params["sites[]"] = selectedSiteResponse.id;
            params.site = selectedSiteResponse.id;
        }

        if ($stateParams.coreClient) {
            params.coreClient = JSON.parse($stateParams.coreClient).v;
        }

        if ($stateParams.serviceProviderGroup) {
            params.serviceProviderGroup = JSON.parse($stateParams.serviceProviderGroup).v;
        }

        if ($stateParams.reporter) {
            params.reporter = JSON.parse($stateParams.reporter).n;
        }

        if ($stateParams.operative) {
            params.operative = JSON.parse($stateParams.operative).v;
        }

        if ($stateParams.sectors) {
            params['sectors[]'] = JSON.parse($stateParams.sectors).v;
        }

        if ($stateParams.assetTypes) {
            params['assetTypes[]'] = JSON.parse($stateParams.assetTypes).v;
        }

        return params;
    }
});
